<template>
    <div>
        <div class="shopping-complete-page">
            <div class="page_top">
                <div class="title" @click="back()">
                    <i class="icon" id="icon"></i>
                    <span class="header-text">購物車</span>
                </div>
            </div>
            <!--內容頁-->
            <div class="page_padding">
                <div class="container-fluid ">
                    <!--狀態顯示列表-->
                    <div class="row">
                        <div class="col-12 my-4">
                            <div class="bg-white p-2 rounded shadow">
                                <el-steps :active="active" finish-status="success" align-center>
                                    <el-step title="確認訂單"></el-step>
                                    <el-step title="確認資料"></el-step>
                                    <el-step title="付款"></el-step>
                                    <el-step title="完成訂單"></el-step>
                                </el-steps>
                            </div>

                        </div>
                    </div>
                    <!--明細列表-->
                    <div class="bg-white rounded shadow">
                        <div v-for="product in 10" :key="product" class="mx-1 ">
                            <div class="row border-bottom p-2">
                                <div class="col-1 d-flex align-items-center">
                                    {{product}}
                                </div>
                                <div class="col-4">
                                    <img src="https://fakeimg.pl/500x500" alt="" class="w-100">
                                </div>
                                <div class="col-7 d-flex flex-column">
                                    <span class="mb-2 lh-base">
                                        Apple iPhone 13 (128G)-午夜色(MLPF3TA/A)
                                    </span>
                                    <div>
                                        <span>單價:</span>
                                        <span class="text-danger my-2">$2999</span>
                                    </div>
                                    <div class="mt-2">
                                        <span class="ml-5">數量3</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!--總金額計算-->
                    <div class="row mt-2 p-2">
                        <div class="col bg-white  rounded shadow">
                            <div class="row p-2 fs-5 my-3">
                                <div class="col-12 d-flex justify-content-between">
                                    <span class="fw-bold">總金額</span>
                                    <span class="fw-bold text-danger ">${{2999*5}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class=" position-fixed w-100 bg-white  adow-sm" style="bottom: 0px;height: 70px;">
            <div class="d-flex justify-content-around align-items-center h-100 ">
                <el-button type="primary" @click="goToIndex" class="w-75">返回商城列表</el-button>
            </div>
        </div>
    </div>

</template>
<script>


    export default {
        components: {},
        mixins: [],
        data() {
            return {
                num: 1,
                value: 1,
                active: 4
            }
        },
        mounted() {
        },
        methods: {
            back() {
                this.$router.go(-1)
            },
            goToIndex() {
                this.$router.push({name: 'Store'})
            },
        }
    }
</script>



